import React from 'react';
import { Container } from './styled';
const LolLineup = () => {
  return <Container>중계 탭에서 확인해주세요</Container>;
};

export default LolLineup;
